import { useQuery } from '@tanstack/react-query'
import { getMemberBalance } from '@/api/map/member'
import { keys } from '@/api/hooks/shared/keys'

/** Lab `Member/getBalance` via CM-API. */
export function useMemberBalance() {
  return useQuery({
    queryKey: keys.memberBalance,
    queryFn: getMemberBalance,
    staleTime: 15_000,
  })
}
